import cn from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import BikeIcon from '../icons/BikeIcon';
import BookingIcon from '../icons/BookingIcon';

type Props = {
  title: string;
  href?: string;
  icon?: 'Bike' | 'Booking';
  className?: string;
  disabled?: boolean;
  loading?: boolean;
};

export default function ButtonNavbar({
  title = '',
  href = '/',
  icon = 'Bike',
  disabled = false,
  loading = false,
}: Props) {
  const { locale, pathname } = useRouter();
  const { t } = useTranslation(['common']);
  return (
    <Link
      href={href}
      passHref
      locale={locale}
      legacyBehavior
      title={title}
      aria-label={title}
    >
      <a
        aria-label="button"
        className={cn(
          'text-subtitle18 group group inline-flex h-full w-full flex-nowrap items-center justify-center whitespace-nowrap px-4 font-bold transition-none focus-visible:outline-none',
          {
            'text-neutral-80 shadow-inner-shadow': pathname === href,
            ' text-neutral-40': pathname !== href,
            'hover:text-neutral-60 ':
              pathname !== href && (!disabled || loading),
            'cursor-not-allowed': disabled && !loading,
            'cursor-wait': loading,
          }
        )}
      >
        <div className="relative mr-2 h-6 w-6">
          {icon === 'Bike' ? (
            <BikeIcon
              className={cn({
                'fill-black': pathname === href,
                'fill-neutral-40': pathname !== href,
                'group-hover:fill-neutral-60 ': pathname !== href && !disabled,
              })}
            />
          ) : (
            <BookingIcon
              className={cn({
                'fill-black': pathname === href,
                'fill-neutral-40': pathname !== href,
                'group-hover:fill-neutral-60 ': pathname !== href && !disabled,
              })}
            />
          )}
        </div>
        {t(`common:page.${title}`)}
      </a>
    </Link>
  );
}
